import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_BASE_URL from '../../config/api';

export const fetchDailyTrivia = createAsyncThunk(
  'trivia/fetchDailyTrivia',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { auth: { token } } = getState();
      if (!token) {
        throw new Error('No authentication token, authorization denied');
      }
      const response = await axios.get(`${API_BASE_URL}/trivia/daily`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch trivia');
    }
  }
);

export const submitTriviaAnswer = createAsyncThunk(
  'trivia/submitTriviaAnswer', 
  async ({triviaId, answer}, { getState, rejectWithValue }) => {
    try {
      const { auth: { token } } = getState();
      if (!token) {
        throw new Error('No authentication token, authorization denied');
      }
      const response = await axios.post(`${API_BASE_URL}/trivia/submit/${triviaId}`,
        { answer },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to submit answer');
    }
  }
);